function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M12 2C8.531 2 5.7 4.86 5.7 8.364a6.402 6.402 0 002.785 5.284C5.275 15.04 3 18.255 3 22h1.8c0-4.027 3.213-7.273 7.2-7.273s7.2 3.246 7.2 7.273H21c0-3.745-2.274-6.962-5.485-8.353a6.361 6.361 0 002.044-2.291c.485-.921.74-1.949.741-2.992C18.3 4.86 15.469 2 12 2zm0 1.818c2.496 0 4.5 2.025 4.5 4.546 0 2.52-2.004 4.545-4.5 4.545s-4.5-2.025-4.5-4.545c0-2.521 2.004-4.546 4.5-4.546z"
            fill={props.isHover ? '#F2C94C' : '#ffffff'}
        />
        </svg>
    )
}
  
  export default SvgComponent